import React from 'react';
import styled from 'styled-components';

import { TokenInfo } from 'zdocs-web-core/lib/token';
import {
  ErrorMessage,
  EXPIRED_TOKEN_ERROR_MESSAGE,
  EXPIRED_TOKEN_ERROR_SUB_MESSAGE,
  INVALID_TOKEN_ERROR_MESSAGE,
  INVALID_TOKEN_ERROR_SUB_MESSAGE,
  UNKNOWN_ERROR_MESSAGE,
  UNKNOWN_ERROR_SUB_MESSAGE,
} from 'zdocs-web-core/lib/error';

import { Header } from './Header';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export enum ErrorPageType {
  Invalid,
  Expired,
  Unknown,
}

export type ErrorPageProps = {
  type: ErrorPageType | null;
  tokenInfo: TokenInfo | null;
};

const mainMessageMap = {
  [ErrorPageType.Expired]: EXPIRED_TOKEN_ERROR_MESSAGE,
  [ErrorPageType.Invalid]: INVALID_TOKEN_ERROR_MESSAGE,
  [ErrorPageType.Unknown]: UNKNOWN_ERROR_MESSAGE,
};
const subMessageMap = {
  [ErrorPageType.Expired]: EXPIRED_TOKEN_ERROR_SUB_MESSAGE,
  [ErrorPageType.Invalid]: INVALID_TOKEN_ERROR_SUB_MESSAGE,
  [ErrorPageType.Unknown]: UNKNOWN_ERROR_SUB_MESSAGE,
};

export default function ErrorPage(props: ErrorPageProps) {
  const name = props.tokenInfo?.payload.zdocs.name ?? undefined;
  const type = props.type ?? ErrorPageType.Unknown;
  const mainMessage = mainMessageMap[type];
  const subMessage = subMessageMap[type];

  return (
    <Container>
      <Header showOnMobile name={name} />
      <ErrorMessage mainMessage={mainMessage} subMessage={subMessage} />
    </Container>
  );
}
